<template>
    <el-table border class="agent-pane" style="width: 100%" :data="agent" header-row-class-name="content-header-row">
        <el-table-column prop="adv_user_id" label="广告主编号" width="188"> </el-table-column>
        <el-table-column prop="account_name" label="广告主账户名" width="188"> </el-table-column>
        <el-table-column prop="agent_name" label="所属代理商"> </el-table-column>
        <el-table-column prop="channel_name" label="渠道销售"> </el-table-column>
        <el-table-column prop="product_name" label="合作产品">
            <template slot-scope="scope">
                <el-tag type="success">{{ scope.row.product_name || '--' }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column width="200" fixed="right" label="操作">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleSimulatedLogin(scope.row.adv_user_id)"
                    >模拟登陆</el-button
                >
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import $util from '@/common/js/util';

export default {
    name: 'DetailAgentPane',
    props: {
        agent: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        // 模拟登陆
        handleSimulatedLogin (advUserId) {
            $util.simulatedLogin(advUserId, 1);
        }
    }
};
</script>
<style lang="less" scoped>
.agent-pane {
    /deep/ .content-header-row {
        color: #303133;
    }
}
</style>
